namespace $ {

	export const $shm_hitalama_compat_crypto_error_message =
		'Ваш браузер устарел и не поддерживает необходимое криптографическое API. Обновите браузер до последней версии.'

	export function $shm_hitalama_compat_crypto_error( error: Error ) {
		const message = String( error?.message ?? error )
		const mentions_api = /(?:SubtleCrypto|Web\s*Crypto|\bcrypto\b|\bsubtle\b|generateKey)/i.test( message )
		const unavailable = /(?:unrecognized|unsupported|not supported|not available|unavailable|not defined|undefined|not a function)/i.test( message )
		if( !mentions_api || !unavailable ) return error
		return new Error( $shm_hitalama_compat_crypto_error_message )
	}

}
